<template>
  <div class="process-list-container">
    <div class="search-container">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="流程名称">
          <el-input
            v-model="searchForm.definition_name"
            placeholder="请输入流程名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="已激活" :value="1" />
            <el-option label="未激活" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-container">
      <div class="table-header">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增流程</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{ textAlign: 'center', backgroundColor: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="definition_no" label="流程编号" width="150" align="center" />
        <el-table-column prop="definition_name" label="流程名称" width="180" align="center">
          <template slot-scope="{ row }">
            <div class="process-name">
              <span>{{ row.definition_name }}</span>
              <div class="process-tags">
                <el-tag v-if="row.is_default" size="mini" type="success">默认</el-tag>
                <el-tag v-if="!row.is_active" size="mini" type="info">未激活</el-tag>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="node_count" label="节点数量" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.node_count || 0 }}个</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="160" align="center" />
        <el-table-column prop="update_time" label="更新时间" width="160" align="center" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.is_active ? 'success' : 'info'" size="small">
              {{ row.is_active ? '已激活' : '未激活' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" icon="el-icon-edit" @click="handleDesign(row)" style="margin-right: 8px;">设计</el-button>
            <el-button type="text" size="small" icon="el-icon-document" @click="handleEdit(row)" style="margin-right: 8px;">编辑</el-button>
            <el-dropdown trigger="click" @command="handleMoreAction($event, row)">
              <el-button type="text" size="small" >更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="!row.is_active" command="activate" icon="el-icon-video-play">
                  激活
                </el-dropdown-item>
                <el-dropdown-item command="delete" :divided="!row.is_active" icon="el-icon-delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiProcessDefinitionList,
  apiProcessDefinitionDelete,
  apiProcessDefinitionStatus,
  apiProcessDefinitionCopy
} from '@/api/service'

export default {
  name: 'ProcessList',

  data () {
    return {
      searchForm: {
        definition_name: '',
        status: ''
      },

      loading: false,
      tableData: [],

      pagination: {
        page: 1,
        size: 20,
        total: 0
      }
    }
  },

  mounted () {
    this.loadTableData()
  },

  methods: {
    // 加载表格数据
    async loadTableData () {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          size: this.pagination.size
        }

        const res = await apiProcessDefinitionList(params)
        this.tableData = res.lists || []
        this.pagination.total = res.count || 0
      } catch (error) {
        console.error('加载数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch () {
      this.pagination.page = 1
      this.loadTableData()
    },

    // 重置
    handleReset () {
      this.searchForm = {
        definition_name: '',
        status: ''
      }
      this.pagination.page = 1
      this.loadTableData()
    },

    // 新增流程
    handleAdd () {
      this.$router.push({
        path: '/work_order/process/add'
      })
    },

    // 编辑流程
    handleEdit (row) {
      this.$router.push({
        path: '/work_order/process/edit',
        query: { id: row.id }
      })
    },

    // 流程设计
    handleDesign (row) {
      this.$router.push({
        path: '/work_order/process/design',
        query: { id: row.id }
      })
    },

    // 复制流程
    async handleCopy (row) {
      try {
        await this.$confirm('确定复制该流程吗？', '提示', {
          type: 'warning'
        })

        await apiProcessDefinitionCopy({ id: row.id })

        this.loadTableData()
      } catch (error) {
        if (error !== 'cancel') {

        }
      }
    },

    // 更多操作
    handleMoreAction (command, row) {
      switch (command) {
        case 'copy':
          this.handleCopy(row)
          break
        case 'activate':
          this.handleActivate(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    },

    // 获取分类标签类型
    getCategoryTagType (category) {
      const types = {
        leave: 'primary', // 请假
        expense: 'success', // 报销
        purchase: 'warning', // 采购
        approval: 'danger' // 审批
      }
      return types[category] || 'info'
    },

    // 获取分类文本
    getCategoryText (category) {
      const texts = {
        leave: '请假',
        expense: '报销',
        purchase: '采购',
        approval: '审批'
      }
      return texts[category] || '其他'
    },

    // 激活流程
    async handleActivate (row) {
      try {
        await this.$confirm('确定启用该流程吗？', '提示', {
          type: 'warning'
        })

        await apiProcessDefinitionStatus({
          id: row.id,
          is_active: 1
        })

        this.loadTableData()
      } catch (error) {
        if (error !== 'cancel') {

        }
      }
    },

    // 删除流程
    async handleDelete (row) {
      try {
        await this.$confirm('确定删除该流程吗？删除后将无法恢复', '提示', {
          type: 'warning'
        })

        await apiProcessDefinitionDelete({ id: row.id })
        this.loadTableData()
      } catch (error) {
      }
    },

    // 分页大小改变
    handleSizeChange (size) {
      this.pagination.size = size
      this.loadTableData()
    },

    // 页码改变
    handleCurrentChange (page) {
      this.pagination.page = page
      this.loadTableData()
    }
  }
}
</script>

<style lang="scss" scoped>
.process-list-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 84px);

  .search-container {
    margin-bottom: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .table-container {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .table-header {
      padding: 15px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ebeef5;

      .header-actions {
        display: flex;
        gap: 10px;
      }
    }

    .process-name {
      display: flex;
      flex-direction: column;
      align-items: center;

      .process-tags {
        margin-top: 4px;
        display: flex;
        gap: 4px;
      }
    }

    .pagination-container {
      padding: 20px;
      text-align: right;
    }
  }
}
</style>
